import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3139, { U3139ROLES } from "./U3139";
import U3139MinutesList from "./components/U3139MinutesList";
import U3139MinutesForm from "./components/U3139MinutesForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3139Routes: RouteObject[] = [
  {
    path: "U3139",
    element: <U2000RequireRole allowedRoles={[U3139ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3139 />,
        children: [
          { index: true, element: <U3139MinutesList /> },
          { path: ":id", element: <U3139MinutesForm /> },
        ],
      },
    ],
  },
];

export default U3139Routes;
